import { socialApi } from './shared';

/** Hand-authored Facebook endpoint copy and examples. */
export const FACEBOOK = socialApi({
  id: 'facebook',
  name: 'Facebook',
  blurb:
    'Public Facebook pages and profiles as structured JSON: pass a page URL or handle, get a normalized payload back. One key, one wallet, billed per request in real dollars.',
  endpoints: {
    profile: {
      description: 'Public page or profile by URL or handle: name, category, about, likes/follower counts and avatar.',
      input: { url: 'https://www.facebook.com/nasa' },
      sample: {
        url: 'https://www.facebook.com/nasa',
        name: 'NASA',
        category: 'Aerospace Company',
        about: 'Explore the universe and discover our home planet.',
        likes: 24_100_000,
        followers: 24_600_000,
        avatarUrl: 'https://facebook.com/nasa/avatar.jpg',
      },
    },
    profile_posts: {
      description: 'List a page’s recent posts by URL or page id with cursor pagination: text, author and permalink.',
      input: { url: 'https://www.facebook.com/nasa' },
      sample: {
        posts: [
          {
            id: '1204545088344463',
            text: 'Watch live as our crew returns home from the International Space Station.',
            url: 'https://www.facebook.com/nasa/posts/1204545088344463',
            author: 'NASA',
          },
        ],
      },
    },
    post: {
      description: 'A single Facebook post by URL: text and engagement counts (likes, comments, shares, views).',
      input: { url: 'https://www.facebook.com/nasa/posts/1204545088344463' },
      sample: {
        id: '25118307061088489',
        text: 'Watch live as our crew returns home from the International Space Station.',
        likes: 2_095,
        comments: 48,
        shares: 133,
        views: 133_000,
      },
    },
    post_comments: {
      description: 'List the comments on a post by URL with cursor pagination: text, author, reactions and reply count.',
      input: { url: 'https://www.facebook.com/nasa/posts/1204545088344463' },
      sample: {
        nextCursor: 'MToxNzc2NDYxMjMw',
        comments: [
          {
            id: 'Y29tbWVudDoxMjA2OTAzNjAxNDgzOTYw',
            text: 'Safe travels home! 🌍',
            author: 'Robin Bergsagel',
            reactions: 95,
            replies: 1,
            createdAt: '2025-09-01T01:10:40.000Z',
          },
        ],
      },
    },
    profile_reels: {
      description: 'List a page’s reels by URL with cursor pagination: caption, view count, permalink and thumbnail.',
      input: { url: 'https://www.facebook.com/nasa' },
      sample: {
        reels: [
          {
            id: 'UzpfSTEwMDA2NDAyNzI0Mjg0OTpWSzox',
            url: 'https://www.facebook.com/reel/1114235920664408',
            caption: 'Inside the rocket assembly building 🚀',
            views: 900_000,
            thumbnail: 'https://facebook.com/reel/1114235920664408/thumb.jpg',
            createdAt: '2025-09-13T20:51:28.000Z',
          },
        ],
      },
    },
  },
});
